import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { FilterDropdownToggle } from 'src/components/Reusable/IndexPage/FilterBar/FilterBar.styles'

export const PillContainer = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 12px;
  border-radius: 20px;
  white-space: nowrap;
  color: ${palette.neutral[800]};
`

export const PillSelectionContainer = styled(FilterDropdownToggle)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 12px;
  border-radius: 20px;
  color: ${palette.neutral[800]};
  cursor: pointer;
  max-width: 100%;
  transition: all 0.15s;
  &:hover,
  &:focus,
  &:active,
  &.show {
    color: ${palette.neutral[800]} !important;
    border: 1px solid none !important;
    box-shadow: none !important;
    filter: brightness(0.9);
  }
`
